import Memos from "@/views/Memos.vue";
import Faq from "@/views/Faq.vue";
import Invoices from "@/views/Invoices.vue";
import Products from "@/views/Products.vue";
import Contact from "@/views/Contact.vue";
import Calendar from "@/views/Calendar.vue";
import PackagingOrders from "@/views/PackagingOrders.vue";
import PharmacistsRouter from "@/router/PharmacistsRouter";
import FormsRouter from "@/router/FormsRouter";
import SettingsRouter from "@/router/SettingsRouter";
import ServiceProductOrderRouter from "@/router/ServiceProductOrderRouter";
import AssortmentUpdate from "@/views/assortmentUpdate/Index.vue";

export default [
  {
    path: "",
    name: "demo",
    component: Memos,
    meta: {
      title: "MijnSPITS"
    }
  },
  {
    path: "faq",
    name: "faq",
    component: Faq,
    meta: {
      title: "Veelgestelde vragen"
    }
  },
  {
    path: "calendar",
    name: "calendar",
    component: Calendar,
    meta: {
      title: "Leveringsafspraken"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (
        (process.env.VUE_APP_LOCATION !== "alkmaar" &&
          process.env.VUE_APP_ENV === "production") ||
        process.env.VUE_APP_ENV !== "production"
      ) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "invoices",
    name: "invoices",
    component: Invoices,
    meta: {
      title: "Facturen"
    }
  },
  {
    path: "packing-order",
    name: "packingorder",
    component: PackagingOrders,
    meta: {
      title: "Inpakopdrachten"
    }
  },
  {
    path: "products",
    name: "products",
    component: Products,
    meta: {
      title: "Assortiment"
    }
  },
  {
    path: "assortment-update",
    name: "assortmenupdate",
    component: AssortmentUpdate,
    meta: {
      title: "Assortimentsupdate"
    }
  },
  {
    path: "contact",
    name: "contact",
    component: Contact,
    meta: {
      title: "Contactgegevens"
    }
  },
  ...PharmacistsRouter,
  ...FormsRouter,
  ...SettingsRouter,
  ...ServiceProductOrderRouter
];
